import { arrayOf } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import Tags from '@features/trend-research/components/common/Tags';

const Images = ({ imageUrl, imageList = [], singleProduct }) => {
	const [selectedImage, setSelectedImage] = useState(null);
	const [currentIndex, setCurrentIndex] = useState(-1);
	const imageRefs = useRef([]);
	const containerRef = useRef(null);
	useEffect(() => {
		setSelectedImage(imageUrl);
	}, [imageUrl]);
	useEffect(() => {
		const index = currentIndex;
		if (index !== -1) {
			setCurrentIndex(index);
		}
	}, [imageList]);

	const scrollToImage = (index) => {
		const imageElement = imageRefs.current[index];
		if (imageElement && containerRef.current) {
			// Ensure the selected image is within the visible part of the container
			imageElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
		}
	};

	const handleBottomClick = () => {
		const nextIndex = currentIndex < imageList.length - 1 ? currentIndex + 1 : 0;
		setCurrentIndex(nextIndex);
		setSelectedImage(imageList[nextIndex]);
		scrollToImage(nextIndex);
	};

	// Handler for top arrow click (moves backward in the image list)
	const handleTopClick = () => {
		const prevIndex = currentIndex > 0 ? currentIndex - 1 : imageList.length - 1;
		setCurrentIndex(prevIndex);
		setSelectedImage(imageList[prevIndex]);
		scrollToImage(prevIndex);
	};

	return (
		<div className="product-list d-flex">
			<div className="slider-nav d-flex flex-column justify-content-start">
				<div className="items scroll-y-label" ref={containerRef}>
					{imageList.map((image, index) => (
						<div
							key={image + '_' + index}
							className={`cursor-pointer nav-single d-flex justify-content-center align-items-center ${
								selectedImage === image ? 'active' : ''
							}`}
							onClick={() => {
								setSelectedImage(image);
								setCurrentIndex(index);
								scrollToImage(index); // Scroll to bring the clicked image into view
							}}
							ref={(el) => (imageRefs.current[index] = el)}
						>
							<img src={image} width="60px" alt="product" />
						</div>
					))}
				</div>
				<div className="slider-arrow">
					<span className="arrow top-arrow" onClick={handleTopClick}>
						<img src={`${process.env.PUBLIC_URL}/icons/angel-top.svg`} alt />
					</span>
					<span className="arrow bottom-arrow" onClick={handleBottomClick}>
						<img src={`${process.env.PUBLIC_URL}/icons/angel-bottom.svg`} alt />
					</span>
				</div>
			</div>
			<div className="pom-product-slider p-0">
				<div className="product-single text-center">
					<img src={selectedImage} alt="product" />
					{singleProduct?.isBestseller && <Tags label="Bestseller" className="yellow-3" />}
					{!singleProduct?.isBestseller && singleProduct?.isNewArrival && (
						<Tags label="New" className="blue-3" />
					)}
				</div>
			</div>
		</div>
	);
};

Images.propTypes = {
	imageList: arrayOf.isRequired
};

export default Images;
